import { render, staticRenderFns } from "./customize_star.vue?vue&type=template&id=60d47324&scoped=true"
import script from "./customize_star.vue?vue&type=script&lang=js"
export * from "./customize_star.vue?vue&type=script&lang=js"
import style0 from "./customize_star.vue?vue&type=style&index=0&id=60d47324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d47324",
  null
  
)

export default component.exports